module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_ny_afpt@2x.032f1b33.png";